import { render, staticRenderFns } from "./DeveloperProfileReview.vue?vue&type=template&id=533c1cc6&scoped=true&"
import script from "./DeveloperProfileReview.vue?vue&type=script&lang=ts&"
export * from "./DeveloperProfileReview.vue?vue&type=script&lang=ts&"
import style0 from "./DeveloperProfileReview.vue?vue&type=style&index=0&id=533c1cc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533c1cc6",
  null
  
)

export default component.exports